import { useSessionStorage } from '@mantine/hooks';

const STORAGE_KEY = 'ai-chat-new-conversation-prompt';

export const useAiChatNewConversation = () => {
    // Session (per-tab) storage on purpose: localStorage syncs across tabs, so a single
    // brainstorm click would make every open tab consume the prompt and send a duplicate
    // chat message. The click and the sidebar that must react to it live in the same tab.
    const [conversationPrompt, setConversationPrompt] = useSessionStorage<string | null>({
        key: STORAGE_KEY,
        defaultValue: null,
    });

    const startNewConversation = (prompt: string) => {
        setConversationPrompt(prompt);
    };

    const clearConversationPrompt = () => {
        setConversationPrompt(null);
    };

    return { conversationPrompt, startNewConversation, clearConversationPrompt };
};
